import { Badge, Tag } from "antd"
import _ from "lodash"
import React from "react"
import { URL_TRUCK } from "../../constants/urls"
import { GET } from "../../frameworks/HttpClient"
import { formatComma } from "../../frameworks/Util"

const SummaryWeightLatex = React.forwardRef((props, ref) => {
  const [sumWeight, setSumWeight] = React.useState(null);

  React.useImperativeHandle(ref, () => ({
    fetch: () => {
      fetchNetWeightSum();
    }
  }));

  const fetchNetWeightSum = async(params) => {
    try {
      const response = await GET(URL_TRUCK.TRUCK_TRANSACTION_DAILY_SUMMARY, {...params})
      setSumWeight(_.get(response, 'data', {}))
    } catch (error) {
      console.log(error.errorMessages)
    }
  }
  
  React.useEffect(() => {
     fetchNetWeightSum();
  },[])

  return(
  <div style={{ marginTop: 15, marginBottom : 15}}>
    {/* {props.showHasLab && <div style={{ display : 'inline'}}>
      รถที่ทำแล็บแล้ว :
      <Tag color="magenta" style={{  marginLeft : 8, fontSize : 14, marginRight : 14 }}> {formatComma(_.get(sumWeight, 'done_lab_count', 0))}</Tag>
    </div>} */}
    <div style={{ display : 'inline'}}>
      น้ำหนักรอลงน้ำยาง (kg) :
      <Tag color="blue" style={{  marginLeft : 8, fontSize : 14, marginRight : 14 }}> {formatComma(_.get(sumWeight, 'pending_well_weight', 0))}</Tag>
    </div>
    <div style={{ display : 'inline'}}>
      น้ำหนักรวมประจำวัน (kg) :
      <Tag color="blue" style={{  marginLeft : 8, fontSize : 14, marginRight : 14 }}> {formatComma(_.get(sumWeight, 'today_net_weight', 0))}</Tag>
    </div>
    <div style={{ display : 'inline'}}>
      น้ำหนักรวมโดยประมาณ (kg) :
      <Tag color="blue" style={{  marginLeft : 8, fontSize : 14, marginRight : 14 }}> {formatComma(_.get(sumWeight, 'estimated_total_weight', 0))}</Tag>
    </div>
  </div>
  )
})

export default SummaryWeightLatex;